<template>
  <div id="app" class="app">
    <sidebar v-if="ready && requiresAuth"></sidebar>
    <navigation v-if="ready && requiresAuth"></navigation>

    <div v-if="ready" :class="getMainClass()">
      <transition :name="transition">
        <router-view :key="this.$route.path"></router-view>
      </transition>
    </div>

    <transition name="spinner">
      <spinner v-show="!ready" :style="ready ? 'animation-play-state:paused' : ''"></spinner>
    </transition>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { Spinner } from 'components/partials'
  import { Sidebar, Navigation } from 'components/layout'
  import moment from 'moment'
  import $ from 'jquery'
  import Messages from 'services/Messages'
  import alpacaRegister from 'modules/alpaca-register'
  import _ from 'lodash'
  import L from 'services/Localization'

  export default {
    name: 'app',
    components: { Sidebar, Navigation, Spinner },
    data() {
      return {
        transition: null,
        serverURI: 'http://10.110.1.10:5103',
        callingAPI: false,
        caller: window.abp,
        appPath: window.$vars.appPath,
        moment: moment()
      }
    },
    beforeMount() {
      if (!this.$store.state.ready.core && this.requiresAuth) {
        this.$store.dispatch('fetch_core')
      } else {
        this.$store.dispatch('set_core')
      }

      Messages.init()
      alpacaRegister.init()
      moment.locale(L.getCurrentLanguage().name)
    },
    computed: {
      requiresAuth() {
        return !this.$route.meta.authorized;
      },
      ...mapState({
        ready: state => state.ready
      })
    },
    watch: {
      '$route'(to, from) {
        if (this.requiresAuth) {
          const toPath = to.path.replace(/^\//, '').split('/')
          const fromPath = from.path.replace(/^\//, '').split('/')
          let newBranch = toPath[1] !== fromPath[1]

          if (newBranch) {
            newBranch = this.$router.options.routes.findIndex(route => route.path === to.path)
            this.transition = newBranch >= this.$store.state.branch ? 'slide--up' : 'slide--down'
            this.$store.commit('core/UPDATE_BRANCH', newBranch)
          } else if (to.params.id && from.params.id || !_.isUndefined(toPath[2])) {
            this.transition = ''
          } else {
            this.transition = toPath.length > fromPath.length ? 'slide--left' : 'slide--right'
          }
        }
      }
    },
    methods: {
      getMainClass() {
        let cssClass = 'app__view'
        if (!this.requiresAuth) {
          cssClass += ' app__view--login'
        }
        return cssClass
      },
      callAPI: function (method, url, data, ajaxParams) {
        this.callingAPI = true
        return this.caller.ajax($.extend(true, {
          url: url,
          type: 'POST',
          data: JSON.stringify(data)
        }, ajaxParams));
      },
      logout: function () {
        this.$store.commit('SET_USER', null)
        this.$store.commit('SET_TOKEN', null)

        if (window.localStorage) {
          window.localStorage.setItem('user', null)
          window.localStorage.setItem('token', null)
        }

        this.$router.push({name: 'login'})
      }
    }
  }

</script>

<style lang="scss">

  @import '~sass/tools';
  @import '~sass/base';
  @import '~sass/components/form';
  @import '~sass/components/view';
  @import '~sass/components/login';

  .app {
    height: 100%;
    display: flex;
    &__view {
      position: relative;
      flex-grow: 1;
      height: calc(100% - 75px);
      margin-top: 75px;
      overflow: hidden;

      &--login {
        margin-top: 0;
        height: 100%;
      }
    }
  }

  .slide {
    transform: translate3d(0, 0, 0);
    &--up,
    &--down,
    &--left,
    &--right {
      &-enter-active {
        transition: all 600ms cb() 300ms;
      }
      &-leave-active {
        transition: all 350ms cb(io);
      }
      &-enter,
      &-leave-to {
        opacity: 0;
      }
    }
    &--up-enter,
    &--down-leave-to {
      transform: translate3d(0, 50%, 0);
    }
    &--down-enter,
    &--up-leave-to {
      transform: translate3d(0, -50%, 0);
    }
    &--left-enter,
    &--right-leave-to {
      transform: translate3d(50%, 0, 0);
    }
    &--right-enter,
    &--left-leave-to {
      transform: translate3d(-50%, 0, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?c25a5a6e